import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "@mywvglobal-shared/mywv-shared/action/signUpAction";
import * as SignUpUtilites from "./signUpUtils.js";
import {ContinueButton} from "../../atoms/Buttons";
import { EmailField } from "../../atoms/TextField";
import { SignUpWrapper } from "../../atoms/Layout";
import Form from "../../atoms/Form/index.js";
import useAlert from "../../../hooks/useAlert.js";
//import { isMobile } from "../../../utilities/deviceUtilities.js";
import { CenteredText, ErrorSpan } from "../../atoms/Common/index.js";
import { gaEvent } from "../../../utilities/analytics.js";
import Loader from "../Loader/index.js";
import DOMPurify from "dompurify";

const SignUpForm = (props) => {
  const { t } = useTranslation();
  const { setAlert } = useAlert();
  const { loginReducer } = useSelector((state) => state);
  const [isContinueDisabled, setIsContinueDisabled] = useState(true);
  const [email, setEmail] = useState("");
  const [isEmailInvalid, setisEmailInvalid] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [errorMessageText, setErrorMessageText] = useState(null);
  const soCode = props?.signUpData?.soCode;
  const languageCode = props?.signUpData?.languageCode;
  const baseURL = props?.signUpData?.baseURL;
    const [showLoader, setLoader] = useState(false);
  const phoneNumber = props?.signUpData?.phoneNumber;
  const signUpFormSettings = props?.signUpData?.signUpFormSettings;
  const dispatch = useDispatch();
  const { signUpReducer } = useSelector((state) => state);
  const { serviceResponse } = signUpReducer?.signUpResponse ?? {};
  const [isErrorOccured, setIsErrorOccured] = useState(false);
  const [errorTitle, setErrorTitle] = useState(null);
  const { persistItemsReducer } = useSelector((state) => state);
  

  const handleProceed = () => {
    gaEvent("Proceed",persistItemsReducer);
  }

  useEffect(() => {
    const reg = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w\w+)+$/;
    const isvalid = reg.test(String(email).toLowerCase());
    if (!isvalid && email !== "") {
      setisEmailInvalid(true);
      setIsContinueDisabled(true);
      setErrorMessageText(t("DT_WVM_ACC_HEAD_00103_PleaEntId"));
    } else {
      setisEmailInvalid(false);
      setIsContinueDisabled(false);
      setErrorMessageText(null);
      // checkSignUpEmail();
    }
  }, [email]);

  useEffect(() => {
    isErrorOccured && setIsErrorOccured(false)
    if(serviceResponse && serviceResponse?.responseCode === "103"){
      setIsErrorOccured(false);
      setIsContinueDisabled(true);
      setisEmailInvalid(true);
      setErrorMessageText(t("AlreadyRegister",{link:`<a href="/oneLogin" >${t("LoginLink")}</a>`}));
    }
    // if(serviceResponse && serviceResponse?.responseCode === "103"){
    if (isContinueDisabled && serviceResponse) {
      const values = SignUpUtilites.checkSignUpResponse(
        serviceResponse,
        signUpFormSettings,
        phoneNumber,
        loginReducer,
        persistItemsReducer
      );
      if (values) {
         setLoader(false);
        setIsErrorOccured(values.isError);
        setErrorTitle(values.title);
        setErrorMessage(values.message);
      }
    }
  }, [serviceResponse]);

  useEffect(() => {
     if (isErrorOccured) {
    setAlert(errorTitle, errorMessage, "error");
    setIsErrorOccured(false);
  }
  }, [isErrorOccured]);

  useEffect(() => {
    const continueButtonStatus = Object.keys(signUpReducer?.signUpResponse).length > 0 ? false : true;
    setIsContinueDisabled(continueButtonStatus);    
  }, [signUpReducer?.signUpResponse]);

  const checkSignUpEmail = () => {
      setIsErrorOccured(false);
      setLoader(true);
      const param = {
        email,
        languageCode,
      };
      const headers = {
        SOCode: soCode,
      };
      !isContinueDisabled && baseURL &&  dispatch(Action.getInAppSponsorSignUpRequest(baseURL, param, headers));
  };

  const onContinueClick=(e)=>{
    e.preventDefault();
    if (!isEmailInvalid && email) {
      checkSignUpEmail();
    }
  }

  const clickHandler =(e)=>{
    const el = e.target.closest("a");
    if (el && e.currentTarget.contains(el) && e?.target?.href?.includes("/oneLogin")) {
      e.preventDefault();
      //props?.setExecuteSignIn(true)
      props?.executeSignIn();
    }
  }

  return(
    <> 
     {showLoader && <Loader loadingText = {t("Loading")}/>}      
    <SignUpWrapper>
    {/* need to check why below condition is present */}
      {/* {isMobile() && <h2 id="sign_up_text">{t("DT_WVM_ACC_HEAD_00100_SignUp")}</h2>}       */} 
      <Form onSubmit={e=>{onContinueClick(e)}}>
        <CenteredText>
        <EmailField 
          className="emailAddress" 
          // type="email" 
          value={email} 
          placeholder={t("DT_WVM_ACC_HEAD_00101_Emai")}
          onChange={(e)=>{setEmail(e.target.value)}} 

          />
          </CenteredText>
          <CenteredText>
            <div className="forgot-container">
              {isEmailInvalid && <ErrorSpan className="text-danger" onClick={(e)=>clickHandler(e)} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize("*"+errorMessageText)}}></ErrorSpan>}
            </div>
          </CenteredText>
          <CenteredText>
          <ContinueButton isContinueDisabled={isContinueDisabled}
            type="submit"
            onClick={()=>handleProceed()}
            >
              <span>{t("DT_WVM_ACC_HEAD_00102_Cont")}</span>
          </ContinueButton>
        </CenteredText>
      </Form>
      
    </SignUpWrapper>
    </>
  )
}

export default SignUpForm